import React from 'react';
import ReactDOM from 'react-dom';
import EoTDiceApp from './EoTDiceApp';
import WarHammerDiceApp from './WarHammerDiceApp';
import RoomSelector from './RoomSelector/RoomSelector';
import SelectDiceTypeApp from './SelectDiceTypeApp';
import './index.css';

import db from './Database/Database';
import auth from './Database/Auth';

const rootEl = document.getElementById('root')

const signOut = () => {
  auth.signOut();
}

// No need for full router - Just basic stuff
const setRoom = (roomName) => {
  // Let the url parser take care of setting the room
  window.location = `/${roomName}`;
}
// Get room name from url
var roomFromUrl = window.location.pathname.slice(1);
if (roomFromUrl && roomFromUrl.length > 0) {
  db.setRoom(roomFromUrl);
}

// When user rolls something
var onUserRollAction = val => {
  val.user = auth.getUser();
  val.room = db.getRoom();
  db.sendResult(val);
};

function fullRender() {
  // Do we need to render a room?
  var room = db.getRoom();
  if (!room) {
    ReactDOM.render(<RoomSelector onRoomSet={setRoom} />, rootEl);
    return;
  }

  if (!db.isLoaded()) {
    ReactDOM.render(<div>Loading...</div>, rootEl);
    return;
  }

  var baseAppProps = {
    results: db.getResults(),
    onUserRollAction: onUserRollAction
  };

  var diceAppType = db.getDiceType();
  var diceApp = null;
  switch (diceAppType) {
    case 'WARHAMMER':
      diceApp = <WarHammerDiceApp {...baseAppProps} />;
      break;
    case 'EOT':
      diceApp = <EoTDiceApp {...baseAppProps} />;
      break;
    default:
      diceApp = <SelectDiceTypeApp />;
  }

  ReactDOM.render(
    <div>
      <button className="btnXSmall btnSignout" onClick={signOut}>&#x2716;</button>
      {diceApp}
    </div>,
    rootEl
  );
}

auth.wrapUI(rootEl, function () {
  db.clearSubscriptions();
  db.subscribeDBUpdates(fullRender);
  db.start();
});



// WEBPACK FOOTER //
// ./src/index.js